import classNames from 'classnames';
import isString from 'lodash-es/isString';
import { ElementType } from 'react';
import { FormattedMessage } from 'react-intl';

import { isMessage } from '../../lib/utils';

import BasicButton, { BasicButtonProps } from '../buttons/BasicButton';

import styles from '../../styles/menus/menu.module.css';

export interface MenuItemProps extends MenuItem {
    active?: boolean;
    className?: string;
    buttonClassName?: string;
    activeClassName?: string;
    [key: string]: unknown;
}

export interface MenuProps extends BasicButtonProps {
    items?: MenuItemProps[];
    buttonComponent?: ElementType;
    clickRef?: string;
    className?: string | null;
    itemsClassName?: string | null;
    itemClassName?: string | null;
    buttonClassName?: string | null;
    activeClassName?: string | null;
}

function Menu({
    items = null,
    buttonComponent: ButtonComponent = BasicButton,
    className = null,
    itemsClassName = null,
    itemClassName = null,
    buttonClassName = null,
    activeClassName = null,
    clickRef = null,
    ...props
}: MenuProps) {
    return (
        <nav className={classNames([styles.container, className])} data-click-ref={clickRef}>
            <ul className={classNames([styles.items, itemsClassName])}>
                {(items || []).map(
                    ({
                        id = null,
                        label = null,
                        icon = null,
                        href = null,
                        external = false,
                        active = false,
                        className: customClassName = null,
                        buttonClassName: customButtonClassName = null,
                        activeClassName: customActiveClassName = null,
                        ...itemProps
                    }: MenuItem) => (
                        <li
                            key={id || href || label}
                            className={classNames([styles.item, itemClassName, customClassName])}
                        >
                            <ButtonComponent
                                {...props}
                                {...itemProps}
                                href={href}
                                external={external}
                                active={active}
                                className={classNames([
                                    styles.button,
                                    buttonClassName,
                                    customButtonClassName,
                                    {
                                        [styles.withIcon]: icon !== null,
                                        [activeClassName]: active && activeClassName !== null,
                                        [customActiveClassName]:
                                            active && customActiveClassName !== null,
                                    },
                                ])}
                            >
                                {isString(icon) ? (
                                    <span
                                        className={classNames([
                                            'material-symbols-rounded',
                                            styles.icon,
                                        ])}
                                    >
                                        {icon}
                                    </span>
                                ) : (
                                    icon
                                )}
                                {isMessage(label) ? (
                                    <FormattedMessage {...(label as any)} />
                                ) : (
                                    label
                                )}
                            </ButtonComponent>
                        </li>
                    ),
                )}
            </ul>
        </nav>
    );
}

export default Menu;
